
<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import downloader from '@/mixins/downloader';
import snackbarMixin from '@/mixins/snackbar';
import RbxConfirmDialog from '@/shared/reybex/RbxConfirmDialog';

export default {
  name: 'QuestionaryListItem',
  components: {
    RbxConfirmDialog,
  },
  mixins: [downloader, snackbarMixin],
  props: {
    questionary: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: 'Soll der Fragenkatalog gelöscht werden?',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.isConfirmDialogDisplayed = false;

      axios.delete(`/questionary/${this.questionary.id}`)
        .then(() => {
          this.showSuccessMessage('Der Fragenkatalog wurde gelöscht.');

          this.$emit('delete');
        })
        .catch(() => {
          this.showErrorMessage('Ein technischer Fehler ist aufgetreten. Der Löschvorgang ist fehlgeschlagen.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/questionary/${questionary.id}`">
        {{ questionary.name }}
      </router-link>
    </td>
    <td>{{ questionary.category.name }}</td>
    <td>
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDeleteRights"
               @click.native="onDelete" flat icon slot="activator" :disabled="questionary.isDelete">
          <v-icon color="red lighten-2" small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </tr>
</template>
